const testing = false;
const url = testing ? "http://0.0.0.0:8000" : "https://api.miracoeurofood.com";

// eslint-disable-next-line import/no-anonymous-default-export
module.exports = {
  testing,
  serverURL: url,
  version: "0.0.4",
};
